import { render, staticRenderFns } from "./CardContratos.vue?vue&type=template&id=b570c950&"
import script from "./CardContratos.vue?vue&type=script&lang=js&"
export * from "./CardContratos.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports